var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "not_found_svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "97%",
    height: "60vh",
    viewBox: "0 0 1014.6 500",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      enableBackground: "new 0 0 1014.6 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BBBFC4;}\r\n\t.st1{fill:#F36E21;}\r\n\t.st2{fill:#6E7680;}\r\n\t.st3{fill:#F05354;}\r\n\t.st4{fill:#EFA020;}\r\n\t.st5{fill:#F9A15F;}\r\n\t.st6{fill:#EAF5F8;}\r\n\t.st7{fill:#EE4E56;}\r\n\t.st8{font-family:'SegoeUI';}\r\n\t.st9{font-size:320px;}\r\n\t.st10{fill:#F7EDE6;}\r\n\t.st11{fill:#CDDAC4;}\r\n\t.st12{fill:#DFD6DC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404_Text",
    transform: "translate(142 239)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st6",
    cx: 784.25,
    cy: 41.16,
    r: 75.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -142, -239)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 248.7548 435.6551)",
    className: "st7 st8 st9"
  }, "404")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    className: "st10",
    cx: 527.25,
    cy: -147.84,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    className: "st10",
    cx: 81.75,
    cy: 155.66,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    className: "st11",
    d: "M110.9-190.8l7.17,35.06l-30.91-8.29L110.9-190.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle-2",
    className: "st12",
    d: "M-63.85-54.84l19.71,96.4l-85.01-22.79L-63.85-54.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle-3",
    className: "st12",
    d: "M840.07-106.03l-33.94-11.31l22.63-22.63L840.07-106.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.77983ee694f75904295b4a41a8c26c4f.svg";
export { ForwardRef as ReactComponent };